exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@use 'sass:map';.no-scroll[data-v-51acb670]{position:relative;z-index:100;overflow:hidden}.group-paywall-illustration[data-v-51acb670]{display:flex;width:100%;justify-content:center;align-items:flex-end;margin-top:32px;margin-bottom:24px}\n", ""]);
